export default __webpack_public_path__ + "static/Industrial-6a3010679100a73745c328690d6e3883.jpg";